import * as React from 'react';
import Box from '../Layout/Box';

const Divider = ({ children, ...rest }) => {
  return (
    <Box
      as="hr"
      height={0}
      borderTopStyle="solid"
      borderTopWidth="divider"
      borderTopColor="divider"
      {...rest}
    />
  );
};

export default Divider;
